import { IconButton, Stack, Tooltip, Typography } from '@mui/material';
import { FC, ReactNode, useState } from 'react';
import { getNightOrDayPalette } from '../../utils/getNightOrDayPalette';
import { Button } from '@mui/material';
import { FormattedMessage, useIntl } from 'react-intl';
import { splitArrayToTwoChunks } from '../../utils/splitArrayToTwoChunks';
import { MoreHorizOutlined } from '@mui/icons-material';

type Props = Readonly<{
	title?: ReactNode;
	header?: ReactNode;
	showHeader?: boolean;
	listItems: ReactNode[];
}>;

export const SummaryList: FC<Props> = ({ header, listItems, showHeader = false, title }) => {
	const [showMore, setShowMore] = useState(false);
	const { first, rest } = splitArrayToTwoChunks(listItems, 8);
	const intl = useIntl();

	return (
		<>
			{title && (
				<Stack gap={2}>
					<Stack direction={'row'} alignItems={'center'} justifyContent={'space-between'}>
						<Typography variant={'body1'} fontWeight={500}>
							{title}
						</Typography>
						<Tooltip title={intl.formatMessage({ id: 'common.coming-soon.tooltip' })}>
							<IconButton>
								<MoreHorizOutlined />
							</IconButton>
						</Tooltip>
					</Stack>
				</Stack>
			)}
			<Stack>
				{showHeader && (
					<Stack
						direction={'row'}
						flexWrap={'nowrap'}
						sx={{ color: (theme) => theme.palette[getNightOrDayPalette(theme)][500] }}
						justifyContent={'space-between'}
						borderTop={(theme) => `1px solid ${theme.palette[getNightOrDayPalette(theme)][200]}`}
						borderBottom={(theme) => `1px solid ${theme.palette[getNightOrDayPalette(theme)][200]}`}
						px={2}
						py={1}
					>
						{header}
					</Stack>
				)}
				{first.map((item, index) => (
					<Stack
						borderTop={(theme) => (index !== 0 ? `1px solid ${theme.palette[getNightOrDayPalette(theme)][200]}` : undefined)}
						key={index}
						py={1.25}
						px={2}
						flexDirection={'row'}
						justifyContent={'space-between'}
					>
						{item}
					</Stack>
				))}
				{showMore &&
					rest.map((item, index) => (
						<Stack
							borderTop={(theme) => `1px solid ${theme.palette[getNightOrDayPalette(theme)][200]}`}
							key={index}
							py={1.25}
							px={2}
							flexDirection={'row'}
							justifyContent={'space-between'}
						>
							{item}
						</Stack>
					))}
				{rest.length > 0 && (
					<Button sx={{ mt: 2, mb: 3 }} variant={'outlined'} onClick={() => setShowMore((prev) => !prev)}>
						<FormattedMessage id={'journey.summary.drawer.list.view-all'} />
					</Button>
				)}
			</Stack>
		</>
	);
};
